module.exports = __webpack_public_path__ + "img/product1.5cf01fa.png";